import axios from "@/utils/request"

// 公告列表
export function getFrontendNoticeList(params) {
  return axios({
    url: "/frontend/systemNotice",
    method: "GET",
    params
  })
}

// getVideo
export function getVideo() {
  return axios({
    url: "/frontend/systemConfig/getTvVideoUrl",
    method: "GET"
  })
}

// 退出登录
export function logout() {
  return axios({
    url: "/api/auth/logout",
    method: "post",
    headers: {
      "Content-Type": "application/json;charset=UTF-8"
    }
  })
}
// 获取利润率
export function profitCal(params) {
  return axios({
    url: "/frontend/basicProduct/profitCal",
    method: "GET",
    params
  })
}
